import { ComponentProps } from 'react';
import ProductCard from '../product-card';
import ColorSwatchStyles from '@components/ColorSwatchStyles';
import ProductFeedSlider from './ProductFeedSlider';

type TProps = {
  title?: string;
  items: any;
  filterOptions: any;
  productCardProps?: Omit<
    ComponentProps<typeof ProductCard>,
    'item' | 'displayPosition' | 'features' | 'siteId'
  >;
  siteId: number;
  useVariantUrl?: boolean;
};

const ProductFeed = ({
  title,
  items = [],
  filterOptions,
  productCardProps = {},
  siteId,
  useVariantUrl = false,
}: TProps) => {
  return (
    <>
      <ColorSwatchStyles
        colors={items && (items.map((item) => item.pickerVariants?.colors) || [[]]).flat().filter((i) => !!i)}
      />
      <ColorSwatchStyles
        colors={filterOptions?.colorGroups && filterOptions?.colorGroups.map((g) => g.config)}
      />

      <div className='tw-z-31 tw-mx-auto tw-max-w-[1480px] tw-pt-10'>
        {title && (
          <h2 className='tw-mx-auto tw-mb-6 tw-px-2 tw-font-body tw-text-base tw-font-extrabold tw-uppercase tw-tracking-[1.6px] tw-text-neutrals-graphite md:tw-text-lg xl:tw-text-2xl'>
            {title}
          </h2>
        )}
        <div className='tw-relative tw-w-full tw-flex-grow'>
          <ProductFeedSlider items={items} productCardProps={{ ...productCardProps, siteId }} />
        </div>
      </div>
    </>
  );
};

export default ProductFeed;
